// extracted by mini-css-extract-plugin
export default {"warning":"CopyKitFormOtherOrgs_warning__GUBBa","placeHolderShimmer":"CopyKitFormOtherOrgs_placeHolderShimmer__5smRN"};